import React, { useEffect, useState, useRef } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faEdit, faFileAlt } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';
import RichTextEditor from '../../../../../components/RichTextEditor';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TabelaListagemFichas from '../../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Api
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import variaveisSistema_api from '../../../../../api/variaveisSistema_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateModeloEmail() {
    return {
        identificacao: "",
        conteudo: "",
        status: "Ativo",
        assunto: "",
        codigo: "",
        imagensConteudo: []
    }
}
export default function CadastroModeloEmail({ btnVoltar, id = null, editavel }) {
    //Estado de controle dos campos obrigatorios 
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "conteudo", required: true }),
        objCampo({ name: "assunto", required: true }),
    ];

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle de visualização do modal de variaveis de substituição
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => setVisibleModal(!visibleModal);


    //Estado que guarda as variaveis para adicionar no email
    const [variaveis, setVariaveis] = useState([
    ]);
    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Codigo", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ]

    //Estado de controle dos campos de cadastro de modelo de email
    const [modeloEmail, setModeloEmail] = useState(initialStateModeloEmail());

    const { setLoading, loading } = useAuth();

    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _modeloEmail = {
            ...modeloEmail,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_modeloEmail, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setModeloEmail(_modeloEmail);
    }

    //Função de load do modelo de email para atualização
    const loadModeloDeEmail = () => {
        setLoading(true);
        modelosEmail_api.getItem(id).then(response => {
            response.data.imagensConteudo = [];
            setModeloEmail(response.data);
            loadVariaveisSistema(response.data.identificacao);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadVariaveisSistema = (identificacao) => {
        setLoading(true);
        variaveisSistema_api.getList(identificacao == "Cadastro de Usuários" || identificacao == "Recuperar Senha" ? "Cadastro de Usuário" : "Requerimento").then(response => {
            setVariaveis(response.data);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que salva as imagens base64 adicionadas no conteudo html
    const setImage = (base64, e) => {
        const _modeloEmail = {
            ...modeloEmail,
            [e.target.name]: e.target.value,
            imagensConteudo: [
                ...modeloEmail.imagensConteudo ? modeloEmail.imagensConteudo : [],
                base64
            ]
        };
        setModeloEmail(_modeloEmail);
    }

    //Função para dar submit nos dados do modelo de email
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(modeloEmail, campos);
        setErrors(_errors[0])

        if (_errors[1].length > 0)
            return;

        //Realizando o cadastro/edição do modelo de email
        const _modeloEmail = { ...modeloEmail };
        setLoading(false);
        if (modeloEmail.id) {
            modelosEmail_api.put(_modeloEmail).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o modelo de e-mail!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        } else {
            modelosEmail_api.post(_modeloEmail).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar o modelo de e-mail!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        }
    }
    useEffect(() => {
        if (id)
            loadModeloDeEmail();
        else 
            loadVariaveisSistema("Requerimento")
    }, []);
    return (
        <>
            <ModalCustomized btnClose={true} isOpen={visibleModal} toggle={toggleModal} title={"Variáveis de substituição"}>
                <TabelaListagemFichas headers={headers} items={variaveis} />
            </ModalCustomized>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h5 className='text-secondary mb-0'>Adicionar modelo de e-mail</h5>

                    <Button onClick={toggleModal}><FontAwesomeIcon icon={faFileAlt} />  Variáveis de substituição</Button>
                </div>
                <Row>
                    <Col md="12" lg="6">
                        <TextField
                            label="* Identificação"
                            name={"identificacao"}
                            onChange={onChange}
                            value={modeloEmail.identificacao}
                            invalid={!!errors.identificacao}
                            disabled={modeloEmail.identificacao == "Cadastro de Usuários" || modeloEmail.identificacao == "Recuperar Senha" || !editavel}

                        />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="* Assunto" name={"assunto"} onChange={onChange} value={modeloEmail.assunto} invalid={!!errors.assunto} disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Status"
                            name={"status"}
                            options={
                                [
                                    { label: "Ativo", value: "Ativo" },
                                    { value: "Inativo", label: "Inativo" }
                                ]
                            }
                            onChange={onChange}
                            value={modeloEmail.status}
                            invalid={!!errors.status}
                            disabled={modeloEmail.identificacao == "Cadastro de Usuários" || modeloEmail.identificacao == "Recuperar Senha" || !editavel}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        {((id && modeloEmail.id) || !id) &&
                            <RichTextEditor saveImage={setImage} name={"conteudo"} value={modeloEmail.conteudo} onChange={onChange} invalid={!!errors.conteudo} disabled={!editavel} />
                        }
                    </Col>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mt-4'>
                        {editavel &&
                            <Button className='px-4' color={id ? 'warning text-white' : 'success'} onClick={onSubmit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}</Button>
                        }
                    </Col>
                </Row>
            </MainCard>
        </>
    );
}